import React from "react";
import "./Video.scss";

/* assets svg */
import metroBrand from "./assets/img/metro.svg";
import perBrand from "./assets/img/per.svg";

const Video = () => {
  return (
    <section className="video" id="initiatives">
      <div className="container">
        <div className="links">
          <div className="link">
            <div className="link_img  ">
              <div className="link_img_src first"></div>
              <img src={metroBrand} className="link_img_brand" />
            </div>
            <div className="link_body">
              <div>
                <div className="link_body_date">
                  10 ноября 2022 – 27 ноября 2023
                </div>
                <div className="link_body_title">Щётка, сдавайся!</div>
                <div className="link_body_text">
                  Сдай старую щётку в торговых центрах «МЕТРО Кэш энд Керри»
                  и получи скидку на покупку новой. А мы позаботимся о природе
                  и переработаем собранный пластик в тротуарную плитку.
                </div>
              </div>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://promo.splatglobal.com/metro-recycle/"
                className="link_body_btn"
              >
                Подробнее
              </a>
            </div>
          </div>
          <div className="link">
            <div className="link_img ">
              <div className="link_img_src sec"></div>
              <img src={perBrand} className="link_img_brand" />
            </div>
            <div className="link_body">
              <div>
                <div className="link_body_date">август 2020 – декабрь 2023</div>
                <div className="link_body_title">Щётка, сдавайся!</div>
                <div className="link_body_text">
                  Сдай старую щётку в супермаркетах «Перекрёсток» и получи
                  кэшбэк с покупки новой. А мы позаботимся о природе и
                  переработаем собранный пластик в тротуарную плитку.
                </div>
              </div>
              <a
                rel="noopener noreferrer"
                href="https://promo.splatglobal.com/x5-recycle/"
                target="_blank"
                className="link_body_btn"
              >
                Подробнее
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Video;
